import { render } from "./Login.vue?vue&type=template&id=3738d180"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render

export default script